import { render } from "./payattitude.vue?vue&type=template&id=e645bf1e"
import script from "./payattitude.vue?vue&type=script&lang=js"
export * from "./payattitude.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__